import React from "react";
import Form from "react-bootstrap/Form";
import { Col, Row } from "react-bootstrap";

export default function EnterAsYouGoFields({ placeholderRef, inputCountRef }) {
    return (
        <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="placeholderControl">
                <Form.Label>Placeholder Text</Form.Label>
                <Form.Control
                    type="text"
                    placeholder="Item Placeholder Text"
                    maxLength="30"
                    ref={placeholderRef}
                    name="Placeholder"
                />
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="inputCountControl">
                <Form.Label>Number of Items</Form.Label>
                <Form.Control
                    type="number"
                    placeholder="0 for infinite"
                    ref={inputCountRef}
                    name="InputCount"
                />
            </Form.Group>
        </Row>
    );
}
